import { columns, mobileColumns } from './Column'

import ReactDataTable from '../../../../../../../components/_shared/Table/ReactDataTable'
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize'
import ReactExpandableTable from '../../../../../../../components/_shared/Table/ReactExpandableTable'
import ReportFooter from '../../ReportsFooter/ReportFooter'
import { useState } from 'react'
const IncidentProcessedByInitialReviewTable = ({
    IncidentProcessedByInitialReviewData,
    handleColumnSort,
    downloadPDF,
    downloadExcel,
    DisplayDate,
    isLoading,
    reportData,
    reportCode,
    reportTableData,
    generatePDFFunction,
}) => {
    const size = useWindowSize()
    const [currentRow, setCurrentRow] = useState(null)
    if (size.width < 768) {
        return (
            <>
                <h1 className="mb-4">Unreviewed Incidents Processed By InitialReview Report</h1>

                <ReactExpandableTable
                    isLoading={isLoading}
                    currentRow={currentRow}
                    setCurrentRow={setCurrentRow}
                    data={IncidentProcessedByInitialReviewData}
                    mobileColumns={mobileColumns}
                    removePagination={true}
                    handleColumnSort={handleColumnSort}
                />
                <ReportFooter
                    BackText={'Back'}
                    PdfText={'PDF'}
                    MailText={'Mail'}
                    ExcelText={'Excel'}
                    onPdfClick={downloadPDF}
                    onExcelClick={downloadExcel}
                    reportData={reportData}
                    reportCode={reportCode}
                    reportTableData={reportTableData}
                    generatePDFFunction={generatePDFFunction}
                />
            </>
        )
    }

    return (
        <>
            <h1 className="mb-4">Unreviewed Incidents Processed By InitialReview Report
            </h1>
            <p className="fw-bold my-2">
                Date :{' '}
                <span className="fw-normal text-muted ">
                    {DisplayDate?.startDate} to {DisplayDate?.endDate}
                </span>
            </p>

            <ReactDataTable
                data={IncidentProcessedByInitialReviewData}
                columns={columns}
                handleColumnSort={handleColumnSort}
                removePagination={true}
                isLoading={isLoading}
            />
            <ReportFooter
                BackText={'Back'}
                PdfText={'PDF'}
                MailText={'Mail'}
                ExcelText={'Excel'}
                onPdfClick={downloadPDF}
                onExcelClick={downloadExcel}
                reportData={reportData}
                reportCode={reportCode}
                reportTableData={reportTableData}
                generatePDFFunction={generatePDFFunction}
            />
        </>
    )
}

export default IncidentProcessedByInitialReviewTable
